import React from 'react';
import PlotMap from './PlotMap';
import RecentContacts from './RecentContacts';

function Dashboard() {
  return (
    <main className="p-4 min-h-screen relative">
        <div className="grid grid-cols-2 gap-4">
          <div className="sm:col-span-1 col-span-2">
            <h1 className="text-2xl font-bold p-2 pb-3">Contacts</h1>
            <RecentContacts />
          </div>
          <div className="sm:col-span-1 col-span-2">
            <h1 className="text-2xl font-bold p-2 pb-3">Map</h1>
            <PlotMap />
          </div>
        </div>
    </main>
  );
}

export default Dashboard;
